import gql from 'graphql-tag';

export default gql`
    mutation MoveBoxes($input: MoveBoxesInput) {
        moveBoxes(input: $input) {
            errors
        }
    }
`;
